import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var LegalBlock = function LegalBlock(_ref) {
  var children = _ref.children,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('button-wrap')
  }, children), text && /*#__PURE__*/React.createElement(Text, {
    color: "grey50",
    size: "size5-r-s"
  }, text));
};
LegalBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  text: PropTypes.string,
  children: PropTypes.node
} : {};